import { render, staticRenderFns } from "./AppQuestion.vue?vue&type=template&id=169431f0&scoped=true&"
import script from "./AppQuestion.vue?vue&type=script&lang=js&"
export * from "./AppQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AppQuestion.vue?vue&type=style&index=0&id=169431f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169431f0",
  null
  
)

component.options.__file = "AppQuestion.vue"
export default component.exports